/* eslint-disable import/prefer-default-export */

// API_BASE_URI for local

// export const API_BASE_URI = '/ecr_tbms/app/webroot/index.php/contact_less_absence_clearance';

// export const API_BASE_URI = '/ecr_tbms/index.php/contact_less_absence_clearance';

// API_BASE_URI for live
export const API_BASE_URI = process.env.REACT_APP_API_HEAD;

// api end points

export const LOGIN = '/login/ecr';
export const GET_PARENT_CONTACT = '/getStudentContacts/ecr';
export const SUBMIT_PARENT_CONTACT = '/notifyParentWithDirectAccessLink/ecr';
export const GET_ABSENCES_DATA = '/getAbsencesData/ecr';
export const SUBMIT_ABSENCE_CLEAR = '/saveAbsenceClearanceFormData/ecr';
// `${API_BASE_URI}/getAbsencesDataForLink/${data.school}/${data.studentId}/${data.token}`
export const GET_ABSENCES_DATA_LINK = '/getAbsencesDataForLink';
export const SUBMIT_EARLY_LEAVE = '/saveEarlyLeaveFormData/ecr';
export const GET_STUDENT_SCHEDULE = '/getStudentSchedule/ecr';
